"use client";

import React from "react";
import { User, Briefcase, Zap, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCommandCenter() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "LOFT CONVERSIONS",
    description: "Specialist loft extension and dormer loft conversion solutions for North West London homes, maximizing attic space with architectural precision and high-end finishes.",
    icon: <User className="size-6 text-foreground" />,
    colSpan: "col-span-1 md:col-span-1 lg:col-span-1",
    link: "/OurCraftPage"
  }, {
    title: "HOME EXTENSIONS",
    description: "Bespoke home extensions, including single and double storey rear extensions and side return extensions designed for modern luxury living and seamless integration.",
    icon: <Briefcase className="size-6 text-foreground" />,
    colSpan: "col-span-1 md:col-span-1 lg:col-span-1",
    link: "/OurCraftPage"
  }, {
    title: "LUXURY RENOVATIONS",
    description: "Trusted builders for complete house refurbishment and property renovation. From kitchen renovation builders to bathroom remodeling, our reliable building contractors deliver comprehensive home transformations in Willesden Green and Wembley.",
    icon: <Zap className="size-6 text-foreground" />,
    colSpan: "col-span-1 md:col-span-2 lg:col-span-2",
    link: "/OurCraftPage"
  }];
  return;
}